// extracted by mini-css-extract-plugin
export default {"loginContainer":"Register_loginContainer__H8tYN","aparecer":"Register_aparecer__B9EpR","main":"Register_main__PfKzt","branding":"Register_branding__UfAcI"};